import {Alert, DialogActions, DialogContent} from "@mui/material";
import {Autocomplete, Button, Field, FieldsContainer, Form, PageHeader, TextField,} from "common";
import I18n from "i18n-js";
import useUserForm, {UseUserFormProps} from "./useUserForm";
import {ROLES} from "../../../app/constants";
import useAccess from "../../profile/useAccess";
import React from "react";

export interface UserFormProps extends UseUserFormProps {
}

export default function UserForm({
                                   id,
                                   afterSave,
                                   onClose,
                                 }: UserFormProps) {
  const {
    item,
    options,
    errors,
    loading,
    isDirty,
    isCreate,
    getIsDirty,
    getRequiredFields,
    onChange,
    save,
    saving,
  } = useUserForm({
    id,
    afterSave,
  });
  const access = useAccess();

  const title = isCreate ? I18n.t("User.addTitle") : I18n.t("User.editTitle");
  return (
    <>
      <PageHeader title={title} onClose={onClose}/>
      <DialogContent>
        <Form
          loading={loading}
          item={item}
          options={options}
          errors={errors}
          onChange={onChange}
          translationCategory="User.attributes"
          isDirty={getIsDirty}
          requiredFields={getRequiredFields()}
        >
          <FieldsContainer>
            <Field fullWidth>
              <TextField id="first_name"/>
            </Field>
            <Field fullWidth>
              <TextField id="last_name"/>
            </Field>
            <Field fullWidth>
              <TextField id="email"/>
            </Field>
            <Field fullWidth>
              <Autocomplete id="status"/>
            </Field>
            <Field fullWidth>
              <Alert severity="warning">
                {I18n.t("User.roleChangeInfo")}
              </Alert>
            </Field>
            <Field fullWidth>
              <Autocomplete id="role" disabled={!access.hasRoles(ROLES.OWNER)}/>
            </Field>
            {item.role === ROLES.BASIC
              ? (
                <Field fullWidth>
                  <Autocomplete
                    id="permissions"
                    multiple
                    getOptionDisabled={(option: any) => {
                      const selectedOptions = item.permissions;
                      const allOptions = options.permissions;
                      const currentPermission = option.value;
                      const match = currentPermission.match(/^(manage|view)(.+)$/);
                      const [type, permission] = [match[1], match[2]];
                      const otherType = type == "view"
                        ? "manage"
                        : "view";
                      const otherPermissionValue = otherType + permission;

                      let otherTypeFound = false;
                      allOptions.forEach((option) => {
                        if (option.value == otherPermissionValue) {
                          otherTypeFound = true;
                        }
                      });

                      if (!otherTypeFound) {
                        return false;
                      }

                      return selectedOptions && type == "view" && selectedOptions.includes(otherPermissionValue);
                    }}
                  />
                </Field>
              )
              : null
            }
          </FieldsContainer>
        </Form>
      </DialogContent>
      <DialogActions>
        <Button
          title={I18n.t("App.save")}
          disabled={!isDirty}
          onClick={() => save()}
          loading={saving}
        />
      </DialogActions>
    </>
  );
}
